import _ from 'lodash'

// Rearranges parameterGroups into objects by id
export const toObject = (parameterGroups) => {
  const resultingObject = _.reduce(
    parameterGroups,
    (result, value) => {
      const subObject = _.reduce(
        value.parameters,
        (res, val) => {
          const id = _.camelCase(val.id)
          _.set(res, id, val)
          _.unset(res.id, 'id') // removes the id value which isn't needed anymore
          return res
        },
        {},
      )
      _.set(result, _.camelCase(value.type), subObject)
      return result
    },
    {},
  )
  return resultingObject
}
